import styled from 'styled-components';

import {
  typography,
} from '../../theme';

export const Wrapper = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 3rem;
  justify-content: center;
  left: 0;
  padding: ${10 / typography.BASE_FONT_SIZE}rem;
  padding-top: ${16 / typography.BASE_FONT_SIZE}rem;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity .2s ease-in-out;

  &.inactive {
    opacity: 0;
  }

  &.active {
    opacity: 1;
  }
`;

export const Helper = styled.div`
  ${typography.BODY__SMALL}
  text-align: center;
  strong {
    ${typography.BODY__SMALL__BOLD}
  }
`;

export const Arrow = styled.div`
  animation: scrollprompt 1s infinite;
  margin: 0 auto;
  text-align: center;
  width: 1rem;
`;

export const ArrowText = styled.div`
  margin: 0 auto;
  text-align: center;
  ${typography.BODY__SMALL__BOLD}
`;



// WEBPACK FOOTER //
// ./src/components/ScrollPrompt/style.js